import React from 'react'
import { Link } from 'react-router-dom'
// Import Img
import money from "../../assets/img/icon/money.png"
import setting from "../../assets/img/icon/setting.png"
import hand from "../../assets/img/icon/hand-round.png"
import icon from "../../assets/img/icon/round.png"


const FaqsTop = () => {
  return (
    <>
        <section id="faqs_arae_top" className="section_padding">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="section_heading">
                        <h3>FAQ</h3>
                        <h2>Answers about <span className="color_big_heading">PCF</span> programmes &amp; events</h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="about_top_boxed bg_one">
                        <div className="about_top_boxed_icon">
                            <img src={money} alt="img" />
                        </div>
                        <div className="about_top_boxed_text">
                            <p>Membership &amp; fees</p>
                            <h3>Costs, waivers, and how support is used</h3>
                            <Link to="/contact">Contact us...</Link>
                        </div>
                        <div className="about_top_boxed_vector">
                            <img src={icon} alt="img" />
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="about_top_boxed bg_two">
                        <div className="about_top_boxed_icon">
                            <img src={setting} alt="img" />
                        </div>
                        <div className="about_top_boxed_text">
                            <p>Integration</p>
                            <h3>Life in Sweden — schools, work &amp; networks</h3>
                            <Link to="/about">Learn more...</Link>
                        </div>
                        <div className="about_top_boxed_vector">
                            <img src={icon} alt="img" />
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                    <div className="about_top_boxed bg_three">
                        <div className="about_top_boxed_icon">
                            <img src={hand} alt="img" />
                        </div>
                        <div className="about_top_boxed_text">
                            <p>Volunteering</p>
                            <h3>Badminton hosts, tutors &amp; social crew</h3>
                            <Link to="/contact">Get involved...</Link>
                        </div>
                        <div className="about_top_boxed_vector">
                            <img src={icon} alt="img" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default FaqsTop
